<template>
	<div id="attendOrders" class="attendOrders">
        <vue-snotify></vue-snotify>
		<nav class="navbar navbar-light">
			<div class="form-inline">
				<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Escanee código aquí" ref="codesearchref"
                    v-model="codeSearch" v-on:keyup.enter="analyzeSearch()" autofocus @focus="$event.target.select()">
                <span v-if="listProductAttend.length > 0">X {{ quantity }}</span>
                <div class="float-right d-none d-sm-inline separator"></div>
                <div class="form-check" v-if="listProductAttend.length == 0">
                    <input type="checkbox" class="form-check-input" id="onlyPrinterCheck" v-model="onlyPrinter">
                    <label class="form-check-label" for="onlyPrinterCheck">Solo imprimir detalle</label>
                </div>
			</div>
			<div class="form-inline">
                <i class="fas fa-broom pointer margin-right5" title="Cerrar" @click="clearAttendsOrders" v-if="listProductAttend.length > 0"></i>
                <i class="fas fa-search pointer margin-right5" title="Buscar pedidos pendientes" @click="searchMovimientosPendientes"></i>
                <i class="fas fa-cog pointer" data-toggle="modal" data-target="#modalSettingModule" ref="openModalSettingModule"></i>
			</div>
		</nav>
        <hr>
	    <div class="row" v-if="listProductAttend.length > 0">
            <div class="col-sm-8">
                <table class="table table-sm table-hover">
                    <thead>
                        <tr class="text-center">
                            <th>#</th>
                            <th>Código</th>
                            <th>Actículo</th>
                            <th>Cantidad</th>
                            <th>
                                <button class="fas fa-print margin-right5"
                                    :class="(successFullConnectionFacturacionCLPrint && listMovimiento.length == 0) ? 'text-success pointer' : 'text-black-50 pointer'"
                                    :title="(successFullConnectionFacturacionCLPrint) ? 'WebSocket FacturacionCL Conectado!!!' : 'No conectada a WebSocket de FacturacionCL'"
                                    @click="toPrintDetail"
                                    v-if="listProductAttend.length > 0"
                                    :disabled="listMovimiento.length > 0">
                                </button>
                                <i class="fas fa-tasks"
                                    :class="(totalRead < totalQuantity) ? 'text-danger' : 'text-success'" :title="totalRead + ' / ' + totalQuantity"
                                    v-if="listProductAttend.length > 0">
                                </i>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in listProductAttend" :key="index" :class="(item.read == item.quantity && totalRead < totalQuantity) ? 'text-muted' : ''">
                            <td>{{ index + 1}}</td>
                            <td :title="'ISBN: ' + item.isbn">{{item.id}}</td>
                            <td>{{item.name}}</td>
                            <td class="text-right">{{item.read}} / {{item.quantity}}</td>
                            <td class="text-center">
                                <i class="fas fa-exclamation-triangle text-danger" v-if="item.read < item.quantity"></i>
                                <i class="fas fa-check text-success" v-else></i>
                                <i class="fas fa-info-circle pointer ml-1 text-info" @click="showProductComponentModalLocal(item.id)"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-sm-4">
				<div class="card card-info card-outline">
					<div class="card-body box-profile" v-if="dataClient.length == 1">
						<h3 class="profile-username text-center">{{ dataClient[0].name }}</h3>

						<p class="text-muted text-center">{{ dataClient[0].sendto }}</p>

						<ul class="list-group list-group-unbordered mb-3">
							<li class="list-group-item">
								<p><b>Dirección:</b> <span>{{ dataClient[0].address }}</span></p>
								<p><b>Comuna:</b> <span>{{ dataClient[0].comuna }}</span></p>
								<p><b>Telefono:</b> <span>{{ dataClient[0].phone }}</span></p>
							</li>
                            <br>
                            <h6 class="text-center">
                                LISTA DE COMPROBANTES <span>({{ cabmovs.length }})</span>
                                <small class="fas fa-print margin-right5 float-right"
                                    :class="(successFullConnectionFacturacionCLPrint) ? 'text-info pointer' : 'text-black-50 pointer'"
                                    :title="(successFullConnectionFacturacionCLPrint) ? 'WebSocket FacturacionCL Conectado!!!' : 'No conectada a WebSocket de FacturacionCL'"
                                    @click="toPrintByObservmov" ref="toPrintByObservmov"
                                    v-show="observtextUnique.length > 1">
                                </small>
                            </h6>
							<li class="" v-for="(item, index) in cabmovs" :key="index" style="margin-top: 5px">
								<b>{{ getInfoTipoComp(item.tipocompcod) }}</b> 
                                <span class="float-right">
                                    {{ item.nrocomp }}  
                                    <i class="far fa-eye margin-right5 pointer" v-if="cabmovs.length > 1"></i>
                                    <i class="fas fa-times text-muted pointer" @click="removeComp(item.fecmov)" v-if="cabmovs.length > 1"></i>
                                </span>
							</li>
						</ul>
                        <button class="btn btn-primary btn-lg btn-block" :disabled="(totalRead < totalQuantity)" @click="saveAttendOrdersFromClick" ref="btnSaveAttendOrders">Guardar</button>
					</div>
					<!-- /.card-body -->
				</div>
				<div class="card card-success card-outline" v-if="1==0">
					<div class="card-body box-profile" v-if="dataClient.length == 1">
						<h3 class="profile-username text-center">{{ dataClient[0].name }}</h3>

						<p class="text-muted text-center">{{ dataClient[0].sendto }}</p>

						<ul class="list-group list-group-unbordered mb-3">
							<li class="list-group-item">
								<b>Dirección:</b> <span>{{ dataClient[0].address }} - {{ dataClient[0].comuna }}</span>
							</li>
                            <br>
                            <h6 class="text-center">
                                LISTA DE COMPROBANTES <span>({{ cabmovs.length }})</span>
                                <small class="fas fa-print margin-right5 float-right"
                                    :class="(successFullConnectionFacturacionCLPrint) ? 'text-info pointer' : 'text-black-50 pointer'"
                                    :title="(successFullConnectionFacturacionCLPrint) ? 'WebSocket FacturacionCL Conectado!!!' : 'No conectada a WebSocket de FacturacionCL'"
                                    @click="toPrintByObservmov" ref="toPrintByObservmov"
                                    v-show="observtextUnique.length > 1">
                                </small>
                            </h6>
							<li class="" v-for="(item, index) in cabmovs" :key="index" style="margin-top: 5px">
								<b>{{ getInfoTipoComp(item.tipocompcod) }}</b> 
                                <span class="float-right">
                                    {{ item.nrocomp }}  
                                    <i class="far fa-eye margin-right5 pointer" v-if="cabmovs.length > 1"></i>
                                    <i class="fas fa-times text-muted pointer" @click="removeComp(item.fecmov)" v-if="cabmovs.length > 1"></i>
                                </span>
							</li>
						</ul>
					</div>
					<!-- /.card-body -->
				</div>
            </div>
        </div>
        <div class="modal" tabindex="-1" role="dialog" id="modalSettingModule">
            <div class="modal-dialog" role="document">
                <div class="modal-content model-sm">
                    <div class="modal-header">
                        <h5 class="modal-title">Configuraciones del Modulo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col" style="margin-top:15px">
                                Producto no encontrado
                            </div>
                            <div class="col">
                                <audio ref="errorProductN" controls>
                                    <source src="@/assets/sound/error1.mp3" type="audio/mp3">
                                </audio>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="margin-top:15px">
                                Cantidad excedida
                            </div>
                            <div class="col">
                                <audio ref="errorProductQ" controls>
                                    <source src="@/assets/sound/error2.mp3" type="audio/mp3">
                                </audio>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="margin-top:15px">
                                Sin comprobante
                            </div>
                            <div class="col">
                                <audio ref="withOutVoucher" controls>
                                    <source src="@/assets/sound/error3.mp3" type="audio/mp3">
                                </audio>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="margin-top:15px">
                                Producto encontrado
                            </div>
                            <div class="col">
                                <audio ref="ok1" controls>
                                    <source src="@/assets/sound/ok1.mp3" type="audio/mp3">
                                </audio>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>

        <button type="button" class="btn btn-primary btn-primary-sm" data-toggle="modal" data-target="#productComponentModal" ref="btnShowProductComponentModal" v-show="false">
            Show Product Component Modal
        </button>
        <div class="modal fade" id="productComponentModal" tabindex="-1" aria-labelledby="productComponentModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-body">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <product-component
                            ref="productComponent"
                            :id="searchProductId"
                            :autoSearch="true"
                            @actionProductFound="actionProductFound"
                            @actionProductNotFound="actionProductNotFoundLocal">
                        </product-component>
                    </div>
                </div>
            </div>
        </div>

	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import genesys from '@/mixins/genesys'
import movimiento from '@/mixins/genesys/movimiento.js'
import domicilio from '@/mixins/genesys/domicilio.js'
import vinvuloArt from '@/mixins/genesys/vinvuloArt.js'
import facturacionCLPrint from '@/mixins/facturacionCLPrint.js'
import suscripcion from '@/mixins/genesys/suscripcion.js'
import { forEach } from '../../../../AdminLTE/src/lib/slideMenuItems'
import shippingRequest from '@/mixins/shippingsRequest'
import transport from '@/mixins/transports'
import trackingShippingRequest from '@/mixins/shippingsRequest/trackingShippingRequest.js'

import ProductComponent from '@/components/ProductComponent.vue'

export default {
	name: 'AttendOrders',
	mixins: [axiosAction, errors, mixin, genesys, movimiento, domicilio, facturacionCLPrint, vinvuloArt, suscripcion, shippingRequest, transport, trackingShippingRequest],
	data() {
		return {
            codeSearch: '',
            listProductAttend: [],
            cabmovs: [],
            climovs: [],
            detmovs: [],
            grupomovs: [],
            dataClient: [],
            observmovs: [],
            quantity: 1,
            codartVinculosArt: [217, 286],
            listMovimiento: [],
            onlyPrinter: false,
            searchProductId: 0
		}
	},
	computed: {
        listProductAttendC() {
            this.listProductAttend = []
            Object.values(this.detmovs).forEach(item => {
                if(item.grupo != 'G') {
                    let index = this.listProductAttend.map((el) => parseInt(el.id)).indexOf(parseInt(item.codart))
                    if(index == -1) {
                        this.listProductAttend.push({'id': item.codart, 'name': item.artdesc, 'isbn': item.isbn, 'quantity': parseInt(item.cantmov), 'read':0, 'onder': item.ubistock})
                    } else {
                        this.listProductAttend[index].quantity = this.listProductAttend[index].quantity + parseInt(item.cantmov)
                    }
                }
            })
            Object.values(this.grupomovs).forEach(item => {
                if(item.grupo != 'G') {
                    let index = this.listProductAttend.map((el) => parseInt(el.id)).indexOf(parseInt(item.codart))
                    if(index == -1) {
                        this.listProductAttend.push({'id': item.codart, 'name': item.artdesc, 'isbn': item.isbn, 'quantity': parseInt(item.cantmov), 'read':0, 'onder': item.ubistock})
                    } else {
                        this.listProductAttend[index].quantity = this.listProductAttend[index].quantity + parseInt(item.cantmov)
                    }
                }
            })
            /*this.listProductAttend.sort(function(a,b) { 
                let x = a.name.toLowerCase();
                let y = b.name.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
            })*/
            this.listProductAttend.sort(function(a,b) { 
                return a.onder - b.onder;
            })
        },
        observtextUnique() {
            let unique = [...new Set(this.observmovs.map(item => item.observtext))]
            return unique
        },
		totalRead() {
			let total = this.listProductAttend.reduce(function(a, b) { let c = parseInt(b.read); return a + c}, 0);
            return parseInt(total.toFixed(0))
		},
		totalQuantity() {
			let total = this.listProductAttend.reduce(function(a, b) { let c = parseInt(b.quantity); return a + c}, 0);
			return parseInt(total.toFixed(0))
        },
	},
	methods: {
        actionProductFound(product) {
            this.$refs.btnShowProductComponentModal.click()
        },
        actionProductNotFoundLocal() {
            alert('El Articulo no se encuentra en la base de datos de iSystem4')
        },
        analyzeCabmovGenesys(data) {
            this.cabmovs.push(data.cabmov)
            this.analyzeObservmovGenesys(data)
        },
        analyzeClimovGenesys(data) {
            this.climovs.push(data.climov[0])
            if(this.dataClient.length == 0) {
                this.dataClient.push({'id': data.climov[0].clicod, 'name': data.climov[0].cargadoa, sendto:'', address:'', comuna:''})
                if(!isNaN(parseInt(data.climov[0].domicod))) {
                    this.getDomicilioWithCliente(data.climov[0].domicod)
                }
                this.analyzeDetmovGenesys(data)
            } else if (this.dataClient.length == 1) {
                if(this.dataClient[0].id == data.climov[0].clicod) {
                    this.analyzeDetmovGenesys(data)
                } else {
                    this.listMovimiento = []
                    alert('Solo se pueden agrupar pedidos del mismo cliente')
                }
            }
        },
        analyzeDetmovGenesys(data) {
            Object.values(data.detmov).forEach(item => {
                this.detmovs.push(item)
            })
            Object.values(data.grupomov).forEach(item => {
                this.grupomovs.push(item)
            })
            this.listProductAttendC
            this.analyzeCabmovGenesys(data)
        },
        analyzeObservmovGenesys(data) {
            let index = data.observmov.map((el) => parseInt(el.resaltar)).indexOf(3)
            if(index == -1) {
                this.observmovs.push({'fecmov': data.cabmov.fecmov, 'succod': data.cabmov.succod, 'itemmov': 0, 'observlin': 1, 'observtext': '', 'resaltar': 3, 'codigo': null})
            } else {
                this.observmovs.push(data.observmov[index])
            }
            this.observmovs.sort(function(a,b) {
                let x = a.observtext.toLowerCase()
                let y = b.observtext.toLowerCase()
                return x < y ? -1 : x > y ? 1 : 0;
            })
        },
        analyzeSearch() {
            this.muteEverything()
            if(this.codeSearch.trim().length == 16 && isNaN(this.codeSearch)) {
                this.listMovimiento.push({'codbareti': this.codeSearch})
                this.getMovimientoByList()
            } else if(this.codeSearch.trim().length == 22 && isNaN(this.codeSearch)) {
                if(this.codeSearch.substring(0,2) == 'ES') {
                    this.objectShippingRequest.barcode = this.codeSearch
                    this.getEnvioSuscripcionByCodetiSeguimov(this.codeSearch.substring(2,18))
                } else if(this.codeSearch.substring(0,2) == 'SE') {
                    if(!isNaN(parseInt(this.codeSearch.substring(2,18)))) {
                        this.objectShippingRequest.barcode = this.codeSearch
                        this.getShippingRequest(parseInt(this.codeSearch.substring(2,18)))
                    }
                }
            } else {
                if(this.codeSearch.trim().length == 13 && !isNaN(this.codeSearch.trim())) {
                    this.searchProductListByCode(this.codeSearch.trim(), 'ISBN')
                } else if(!isNaN(this.codeSearch)) {
                    this.quantity = (this.codeSearch > 0 && this.listProductAttend.length > 0) ? this.codeSearch : this.quantity
                    this.codeSearch = ''
                } else if (this.codeSearch.length > 2 && this.codeSearch.substring(0,1).toUpperCase() == 'H' && !isNaN(this.codeSearch.substring(1,this.codeSearch.length))){
                    this.searchProductListByCode(this.codeSearch.substring(1,this.codeSearch.length), 'INT')
                } else {
                    console.info('No se puede determinar que hacer con este dato ' + this.codeSearch)
                    this.setFocuscodesearchref()
                }
                console.log('No tengo idea que hacer con esto')
            }
        },
        clearAttendsOrders() {
            this.codeSearch = ''
            this.listProductAttend = []
            this.cabmovs = []
            this.climovs = []
            this.grupomovs = []
            this.detmovs = []
            this.observmovs = []
            this.dataClient = []
            this.quantity = 1
            this.setFocuscodesearchref()
            this.listMovimiento = []
        },
        getNroCompByFecmov(fecmov) {
            let index = this.cabmovs.map((el) => el.fecmov).indexOf(fecmov)
            return this.cabmovs[index].nrocomp
        },
		getShippingRequestResultLocal(response) {
            if(response.data.success) {
                if(response.data.data.shipping_request_genesys_cabmov.length > 0) {
                    let cabmovs = response.data.data.shipping_request_genesys_cabmov
                    Object.entries(cabmovs).forEach(([key, item]) => {
                        if(item.tipocompcod == 20 || item.tipocompcod == 40 || item.tipocompcod == 120 ) {
                            this.listMovimiento.push(item)
                        }
                    });
                    if(this.listMovimiento.length > 0) {
                        this.getMovimientoByList()
                    }
                }
            }
		},
        getTipoCompByFecmov(fecmov) {
            console.log(fecmov, this.cabmovs)
            let index = this.cabmovs.map((el) => el.fecmov).indexOf(fecmov)
            return this.getInfoTipoComp(this.cabmovs[index].tipocompcod)
        },
        getEnvioSuscripcionByCodetiSeguimovResultLocal(response) {
            if(response.data.data.length > 0) {
                this.listMovimiento = response.data.data
                this.getMovimientoByList()
            } else {
                this.objectShippingRequest.barcode = ''
            }
        },
        getMovimientoByList() {
            if(this.listMovimiento.length > 0) {
                this.codeSearch = this.listMovimiento[0].codbareti
                this.listMovimiento.splice(0,1)
                this.getMovimiento(this.codeSearch)
            } else {
                if(this.onlyPrinter) {
                    this.toPrintDetail()
                    this.clearAttendsOrders()
                }
                this.$emit('hideLockScreen');
            }
        },
		initModuleLocal() {
			this.setTitleModule('Atención de Pedidos')
            this.setSubTitleModule('')
            this.getVinvuloArt(this.codartVinculosArt)
            this.analyzeSearch()
            this.getAllTransports()
        },
        muteEverything() {
            this.stopSound(this.$refs.ok1)
            this.stopSound(this.$refs.errorProductN)
            this.stopSound(this.$refs.errorProductQ)
            this.stopSound(this.$refs.withOutVoucher)
        },
        removeComp(fecmov) {
            this.cabmovs = this.cabmovs.filter(function (cabmov) { return !(cabmov.fecmov == fecmov) })
            this.climovs = this.climovs.filter(function (climov) { return !(climov.fecmov == fecmov) })
            this.detmovs = this.detmovs.filter(function (detmov) { return !(detmov.fecmov == fecmov) })
            this.observmovs = this.observmovs.filter(function (observmov) { return !(observmov.fecmov == fecmov) })
            if(this.cabmovs.length == 0) {
                this.dataClient = []
                this.clearAttendsOrders()
            }
            this.listProductAttendC
            return true
        },
		resultAxiosLocal(responseLocal, response) {
			switch(responseLocal) {
				case 'getDomicilioWithClienteResult': this.getDomicilioWithClienteResult(response); break;
				case 'getMovimientoResult': this.getMovimientoResult(response); break;
				case 'getShippingRequestResult': this.resultAxiosLocalShippingRequest(responseLocal, response); break;
				case 'resultSaveAttendGenesys': this.resultSaveAttendGenesys(response); break;
				case 'getAllTransportsResult': this.resultAxiosLocalTranspor(responseLocal, response); break;
				case 'resultSaveShippingRequestPOST': this.resultSaveShippingRequestPOST(responseLocal, response); break;
				case 'resultAddShippingRequestTrackingsShippingRequestPOST': this.resultAddShippingRequestTrackingsShippingRequestPOST(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
			this.$emit('hideLockScreen')
		},
        resultAddShippingRequestTrackingsShippingRequestPOST(response){
            setTimeout(this.$snotify.success('Solicitud de envío ' + response.data.data.shipping_request_id + ' atendido!!!', 'OK'), 1000);
            this.socketEmit(['NEW_SHIPPING_REQUEST_TRACKINGS_SHIPPING_REQUEST'], response.data.data)
        },
        getDomicilioWithClienteResult(response) {
            if(response.data.data.length == 1) {
                this.dataClient[0].sendto = response.data.data[0].clinom + ' ' + response.data.data[0].cliape
                this.dataClient[0].address = response.data.data[0].domicalle
                this.dataClient[0].address+= (response.data.data[0].dominro != null) ? ' ' + response.data.data[0].dominro: '' 
                this.dataClient[0].comuna = response.data.data[0].dptodesc
                this.dataClient[0].phone = response.data.data[0].domitel
                this.dataClient[0].transportId = this.searchIdTransportsByStr(response.data.data[0].trandesc)
                this.dataClient[0].transport = response.data.data[0].trandesc
            }
        },
        getMovimientoResultLocal(response) {
            if(typeof response.data === 'string') {
                this.$refs['codeSearch'].select()
            } else if(typeof response.data === 'object') {
                if(!isNaN(parseInt(response.data.data.cabmov.nrocomp))) {
                    if(response.data.data.climov.length == 1 && response.data.data.detmov.length > 0 && this.validateCabmov(response.data.data)) {
                        this.analyzeClimovGenesys(response.data.data)
                        this.codeSearch = ''
                        this.getMovimientoByList()
                    }
                }
            }
            this.setFocuscodesearchref()
        },
        resultSaveAttendGenesysLocal(response) {
            if(response.data.status == 200) {
                if(this.removeComp(response.data.fecmovOri)) {
                    this.saveAttendOrders()
                }
            } else {
                console.log(response)
            }
        },
        resultSaveShippingRequestPOST(responseLocal, response) {
            this.$snotify.success('Se agregó Solicitud de envío Nº ' + response.data.data.id, 'OK')
            setTimeout(this.addShippingRequestTrackingsShippingRequest(response.data.data.id, 10),500);
            this.clearObjectShippingRequest()
        },
        saveAttendOrdersFromClick() {
            if(this.cabmovs.length > 0) {
                this.objectShippingRequest.commentary = 'Susc ' + this.dataClient[0].name
                this.objectShippingRequest.totalPrice = this.cabmovs.reduce((p,c)=>parseInt(p) + parseInt(c.brutocomp), 0)
                this.setRecipientData(this.dataClient[0].sendto, this.dataClient[0].address, this.dataClient[0].comuna, this.dataClient[0].phone, 1, this.dataClient[0].transportId, this.dataClient[0].transport)
                if(this.observtextUnique.length > 1) {
                    this.$refs.toPrintByObservmov.click()
                }
                this.saveAttendOrders()
            }
        },
        saveAttendOrders(){
            if(this.cabmovs.length > 0) {
                let item = this.cabmovs[0]
                this.setCabmovs(item.tipocompcod, item.fecmov, item.succod, item.codbareti, item.nrocomp)
                let detmov = []
                Object.values(this.detmovs).forEach(it => {
                    if(item.fecmov == it.fecmov && item.succod == it.succod)
                        detmov.push(it)
                })
                let grupomov = []
                Object.values(this.grupomovs).forEach(it => {
                    if(item.fecmov == it.fecmov && item.succod == it.succod)
                        grupomov.push(it)
                })
                let climov = []
                Object.values(this.climovs).forEach(it => {
                    if(item.fecmov == it.fecmov && item.succod == it.succod)
                        climov.push(it)
                })
                this.saveAttendGenesys(item, detmov, grupomov, climov)
            } else {
                if(this.objectShippingRequest.barcode != '') {
                    if(this.objectShippingRequest.barcode.substring(0,2) == 'ES') {
                        setTimeout(this.saveShippingRequest, 500)
                    } else if(this.objectShippingRequest.barcode.substring(0,2) == 'SE' && !isNaN(parseInt(this.objectShippingRequest.barcode.substring(2,18)))) {
                        setTimeout(this.addShippingRequestTrackingsShippingRequest(this.objectShippingRequest.barcode.substring(2,18), 10),500);
                    }
                }
                console.log('No hay nada más por guardar')
            }
        },
        searchProductListByCode(code, type) {
            if(this.listProductAttend.length > 0) {
                let index = (type == 'INT') ? this.listProductAttend.map((el) => parseInt(el.id)).indexOf(parseInt(code)) : this.listProductAttend.map((el) => parseInt(el.isbn)).indexOf(parseInt(String(code).substring(3, 13)))
                if(index > -1) {
                    this.toDiscount(index, this.quantity)
                } else {
                    index = (type == 'INT') ? this.vinculoArt.map((el) => parseInt(el.codartvin)).indexOf(parseInt(code)) : this.vinculoArt.map((el) => parseInt(el.isbn)).indexOf(parseInt(code))
                    index = (type == 'ISBN' && index == -1) ? this.vinculoArt.map((el) => parseInt(el.isbn)).indexOf(parseInt(String(code).substring(3, 13))) : index
                    if(index > -1)
                        index = this.listProductAttend.map((el) => parseInt(el.id)).indexOf(parseInt(this.vinculoArt[index].codart))
                    if(index > -1) {
                        this.toDiscount(index, this.quantity, this.vinculoArt[index].codart)
                    } else {
                        this.$refs.errorProductN.play()
                        alert('No se encuentra el articulo con este codigo ' +  code)
                    }
                }
            } else {
                this.$refs.withOutVoucher.play()
                alert('No hay nigún comprobante por atender')
            }
        },
        searchMovimientosPendientes() {
            this.getMovimientoSinAtender()
        },
        setFocuscodesearchref() {
            setTimeout(() => {
                this.$refs.codesearchref.focus()
                this.$refs.codesearchref.select()
            }, 10);
        },
        showProductComponentModalLocal(id) {
            this.searchProductId = id
            setTimeout(() => {this.$refs.productComponent.$refs.btnGetProduct.click()}, 100)
        },
        toDiscount(index, quantity, codart = 0) {
            if((parseInt(quantity) + parseInt(this.listProductAttend[index].read)) > parseInt(this.listProductAttend[index].quantity)) {
                this.$refs.errorProductQ.play()
                alert('La cantidad es mayor a la que se pide')
                this.codeSearch = ''
            } else {
                this.listProductAttend[index].read = parseInt(this.listProductAttend[index].read) + parseInt(quantity)
                if(codart != 0) {
                    forEach
                }
                this.quantity = 1
                this.codeSearch = ''
                if(this.totalQuantity == this.totalRead) {
                    setTimeout(() => { 
                        if(confirm('Se completo el pedido. ¿Desea guardarlo?')) {
                            this.$refs.btnSaveAttendOrders.click()
                        }
                    }, 100);
                } else {
                    this.$refs.ok1.play()
                }
            }
        },
        toPrintDetail() {
            if(this.successFullConnectionFacturacionCLPrint) {
                this.toPrintDetailGenesys()
            } else {
                this.connectFacturacionCLPrint()
            }   
        },
        toPrintByObservmov() {
            console.log(2)
            console.group('Detalles de ' + this.dataClient[0].name)
            let observtext = ''
            let detail = ''
            let tipocomp = ''
            Object.values(this.observmovs).forEach(item => {
                if(detail != '' && observtext != item.observtext.trim() && item.observtext.trim() != '') {
                    detail+= '(' + tipocomp + ')\n'
                    tipocomp = ''
                    observtext = item.observtext.trim()
                    detail+= this.repeatCharacter('#', 64) + '\n'
                    detail+= this.repeatCharacter(' ', 32 - parseInt(observtext.length / 2)) + '!!' + observtext + '!\n' + '\n'
                    detail+= this.repeatCharacter('#', 64) + '\n'
                } else if(item.observtext.trim() == '' && observtext != this.dataClient[0].sendto.trim()) {
                    tipocomp = ''
                    observtext = this.dataClient[0].sendto.trim()
                    detail+= this.repeatCharacter('#', 64) + '\n'
                    detail+= this.repeatCharacter(' ', 32 - parseInt(observtext.length / 2)) + '!!' + this.dataClient[0].sendto + '!\n' + '\n'
                    detail+= this.repeatCharacter('#', 64) + '\n'
                } else if(item.observtext.trim() != '' && observtext != item.observtext.trim() ) {
                    tipocomp = ''
                    observtext = item.observtext.trim()
                    detail+= this.repeatCharacter('#', 64) + '\n'
                    detail+= this.repeatCharacter(' ', 32 - parseInt(observtext.length / 2)) + '!!' + observtext + '!\n' + '\n'
                    detail+= this.repeatCharacter('#', 64) + '\n'
                }
                Object.values(this.detmovs).forEach(it => {
                    if(it.fecmov == item.fecmov) {
                        detail+= this.cleanedStringZPL(it.artdesc.toUpperCase()) + '\n'
                        detail+= it.codart
                        detail+= this.repeatCharacter(' ', 64 - String(it.codart).length - String(parseInt(it.cantmov)).length)  + parseInt(it.cantmov) + '\n'
                        detail+= this.repeatCharacter('-', 64) + '\n'                        
                    }
                })
                tipocomp+= (tipocomp == '' ) ? this.getTipoCompByFecmov(item.fecmov) + this.getNroCompByFecmov(item.fecmov) : ', ' + this.getTipoCompByFecmov(item.fecmov) + this.getNroCompByFecmov(item.fecmov)
            })
            detail+= '(' + tipocomp + ')\n'
            this.printFacturacionCL(window.btoa(detail), '', '', localStorage.printerFacturacionCL)
            console.groupEnd()
        },
        toPrintDetailGenesys(){
            let detail = this.repeatCharacter('#', 64) + '\n'
                detail+= this.repeatCharacter(' ', 32 - parseInt(this.dataClient[0].name.length / 2)) + '!!' + this.dataClient[0].name + '!\n'
                detail+= this.repeatCharacter(' ', 32 - parseInt(this.dataClient[0].sendto.length / 2)) + this.dataClient[0].sendto + '\n'
                detail+= this.repeatCharacter('#', 64) + '\n'
            Object.values(this.listProductAttend).forEach(item => {
                detail+= this.cleanedStringZPL(item.name.toUpperCase()) + '\n'
                detail+= item.id
                detail+= this.repeatCharacter(' ', 64 - String(item.id).length - String(item.quantity).length)  + item.quantity + '\n'
                detail+= this.repeatCharacter('-', 64) + '\n'
            })
            detail+= this.repeatCharacter(' ', 47 - String(this.totalQuantity).length) + 'TOTAL PRODUCTOS: ' + this.totalQuantity + '\n'
            detail+= this.repeatCharacter('#', 64) + '\n'
            let string = 'GyEBHSEBQ09SUE9SQUNJT04gSUdMRVNJQSBERSBMT1MgQURWRU5USVNUQVMgREVMIFNFUFRJTU8bIQENClJVVDogODIuNzQ1LjMwMC01DQpHSVJPOiBSRUxJR0lPU0EsIEVEVUNBQ0lPTkFMLCBSQURJTyBZIFRFTEVWSVNJT04sIENBU0EgRURJVE9SQSwgQUdSSUNPTEEsIEFMQkVSR1VFDQoNCkNBU0EgTUFUUklaOiBBLiBBTUVSSUNPIFZFU1BVQ0lPIE5PUlRFIDEzNA0KQ29tdW5hOiBMQVMgQ09OREVTIC0gQ2l1ZGFkOiBTQU5USUFHTw0KLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0NCkJvbGV0YSBFbGVjdHJvbmljYSBOcm8uOiAyMDI3MDcgICAgICAgICAgDQpGZWNoYSBFbWlzacOzbjogMTAtMDgtMjAyMCAgICAgICAgICAgICAgIA0KLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0NCkRlc2NyaXBjaW9uDQpDb2RpZ28gICAgICAgICAgICAgICBDYW50LiAgICAgICAgIFVuaXRhcmlvICAgICAgICBWYWxvcg0KLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0NCkxpYnJvIG1pc2lvbmVybyAyMDIwIC0gTGEgbWF5b3IgZXNwZXJhbnphIChUKSAgICAgIA0KMTEzODYgICAgICAgICAgICAgICAxNTAsMDAgeCAgICAgICAgICAgIDQ1MCAgICAgICA2Ny41MDANCh0hASAgICAgICAgICAgICAgICAgICAgIFQgTyBUIEEgTCAgICAgICAgICAgICAgICAgIDY3LjUwMCAbIQENCg0K'
            let cabecera = window.atob(string).split('\n')
            this.printFacturacionCL(window.btoa(detail), '', '', localStorage.printerFacturacionCL)
        },
        validateCabmov(data){
            let estadocod = this.getEstadoCod(data.cabmov.tipocompcod, 'ETIQUETA_ATENDIDA')
            let index = data.seguimov.map((el) => parseInt(el.estadocod)).indexOf(parseInt(estadocod))
            if(index > -1) {
                alert('El comprobante "' + this.getInfoTipoComp(data.cabmov.tipocompcod) + data.cabmov.nrocomp + '" ya está atendido')
                return false
            }
            index = this.cabmovs.map((el) => el.fecmov).indexOf(data.cabmov.fecmov)
            if(index > -1) {
                alert('El comprobante "' + this.getInfoTipoComp(data.cabmov.tipocompcod) + data.cabmov.nrocomp + '" ya está incluido en esta lista')
                return false
            }
            return true
        },
	},
	components: {
        'product-component': ProductComponent,
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
audio {
display: block;
  border-radius: 20px;
  margin:0 auto;
}
</style>